import { useEffect } from 'react';
import { useBoolean } from 'ahooks';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

import { TFieldProps } from 'types';

type TToggleField = Omit<TFieldProps, 'name' | 'type'>;

export const withToggleField = (Component: React.FC<TToggleField>): React.FC<TToggleField> => {
  function NewComponent(props: TToggleField) {
    const [enabled, { set }] = useBoolean(false);

    useEffect(() => {
      set(!!props?.value);
    }, [props?.value]);

    const handleToggle = (event: CheckboxChangeEvent) => {
      set(event.target.checked);

      if (!event.target.checked) {
        props?.onChange?.(null);
      }
    };

    return (
      <>
        <Checkbox
          checked={enabled}
          onChange={handleToggle}
          className='mb-2'
        />

        <Component
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          value={enabled ? props?.value : null}
          disabled={!enabled}
        />
      </>
    );
  }

  return NewComponent;
};
